module.exports = __webpack_public_path__ + "assets/23133233adc8b6b8f02374847a615de4.mp3";